import { render } from "./Travesia.vue?vue&type=template&id=15a063a3&scoped=true&ts=true"
import script from "./Travesia.vue?vue&type=script&lang=ts"
export * from "./Travesia.vue?vue&type=script&lang=ts"

import "./Travesia.vue?vue&type=style&index=0&id=15a063a3&scoped=true&lang=css"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a063a3"]])

export default __exports__